module.exports = __webpack_public_path__ + "img/grid.d94675fe.svg";